import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/motion";
import { PageHero, CtaSection } from "../components/common";
import { BLOG_POSTS, BLOG_CATEGORIES } from "../data/site";

export default function Blog() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? BLOG_POSTS : BLOG_POSTS.filter((p) => p.category === cat);

  return (
    <>
      <Seo
        title="STERILTRON Insights | Blog on Medical Waste Treatment & Sterilization"
        description="Insights, technologies and developments shaping the future of medical waste treatment and sterilization from STERILTRON."
        path="/blog"
      />
      <PageHero
        label="Blog"
        titleLines={["STERILTRON Insights"]}
        description="Insights, technologies and developments shaping the future of medical waste treatment and sterilization."
      />

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-3 mb-12">
            {BLOG_CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`blog-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`px-5 py-2.5 text-xs font-semibold uppercase tracking-wider border transition-colors ${
                  cat === c ? "bg-brand-800 text-white border-brand-800" : "bg-white text-slate-600 border-slate-300 hover:border-brand-800 hover:text-brand-800"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block bg-white border border-slate-200 hover:border-brand-800 transition-colors h-full">
                  <div className="overflow-hidden">
                    <img src={p.image} alt={p.title} loading="lazy" className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-3 text-xs uppercase tracking-widest">
                      <span className="text-brand-700 font-semibold">{p.category}</span>
                      <span className="text-slate-300">/</span>
                      <span className="text-slate-500">{p.date}</span>
                    </div>
                    <h2 className="mt-4 font-heading text-xl font-semibold tracking-tight text-brand-950 leading-snug">{p.title}</h2>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-brand-800 group-hover:gap-2.5 transition-all">Read More <ArrowUpRight size={14} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaSection />
    </>
  );
}
